const offer = document.querySelector("#offer");
const offerForm = offer?.querySelector(".hydraflow-product-form");
const packageCards = Array.from(offer?.querySelectorAll(".package-card") || []);
const offerModeButtons = Array.from(offer?.querySelectorAll("[data-offer-mode]") || []);
const offerSummaryPrice = offer?.querySelector("[data-offer-summary-price]");
const offerSummaryCompare = offer?.querySelector("[data-offer-summary-compare]");
const offerNote = offer?.querySelector("[data-offer-note]");
const offerButton = offer?.querySelector("[data-offer-submit]");
const offerSavings = offer?.querySelector("[data-offer-savings]");
const offerDelivery = offer?.querySelector("[data-offer-delivery]");
const subscriptionAvailable = offer?.dataset.subscriptionAvailable === "true";
let offerMode = subscriptionAvailable ? "subscription" : "one-time";

const setOfferProperty = (key, value) => {
  const input = offerForm?.querySelector(`[data-sc-property="${key}"]`);
  if (input) input.value = value;
};

const selectPackageCard = (card) => {
  const input = card?.querySelector('input[name="id"]');
  if (!card || !input || input.disabled) return;

  input.checked = true;
  packageCards.forEach((item) => item.classList.toggle("selected", item === card));
  updateOfferSummary(card);
};

packageCards.forEach((card) => {
  const input = card.querySelector('input[name="id"]');

  card.addEventListener("click", () => selectPackageCard(card));
  input?.addEventListener("change", () => {
    if (input.checked) selectPackageCard(card);
  });
});

const getSelectedPackageCard = () => {
  return packageCards.find((card) => card.querySelector('input[name="id"]')?.checked)
    || packageCards.find((card) => card.classList.contains("selected"))
    || packageCards[0];
};

function updateOfferSummary(card = getSelectedPackageCard()) {
  if (!card) return;
  const price = offerMode === "one-time" ? card.dataset.oneTimePrice : card.dataset.subscriptionPrice;
  const compare = card.dataset.comparePrice;
  if (offerSummaryPrice && price) offerSummaryPrice.textContent = price;
  if (offerSummaryCompare && compare) offerSummaryCompare.textContent = compare;

  const sellingPlanInput = offerForm?.querySelector("[data-sc-selling-plan]");
  if (sellingPlanInput) {
    const isSubscription = offerMode === "subscription";
    sellingPlanInput.disabled = !isSubscription;
    sellingPlanInput.value = isSubscription ? card.dataset.sellingPlanId || "" : "";
  }

  setOfferProperty("purchase_type", offerMode === "subscription" ? "Subscribe & Save" : "One-Time Purchase");
  setOfferProperty("boxes", card.dataset.boxLabel || "");
  setOfferProperty("delivery", offerMode === "subscription" ? card.dataset.delivery || "" : "One-time purchase");
  if (offerDelivery) {
    offerDelivery.textContent = offerMode === "subscription"
      ? (card.dataset.delivery || "Delivered on subscription").replace("Delivered", "Ships")
      : "Ships once";
  }
  if (offerSavings) {
    offerSavings.textContent = offerMode === "one-time"
      ? `Save ${card.dataset.oneTimeSavingsRate || 0}% today`
      : `${card.dataset.subscriptionTotalSavingsRate || 0}% off regular price`;
  }
  if (offerButton) {
    offerButton.textContent = offerMode === "one-time"
      ? "Add To Cart - One-Time Purchase"
      : "Subscribe & Save — Up to 62% Off Regular Price";
  }
}

const updateOfferMode = (mode) => {
  offerMode = mode === "subscription" && subscriptionAvailable ? "subscription" : "one-time";
  offerModeButtons.forEach((button) => {
    const isActive = button.dataset.offerMode === offerMode;
    button.classList.toggle("active", isActive);
    button.classList.toggle("selected", isActive);
    button.setAttribute("aria-pressed", String(isActive));
  });

  offerForm?.querySelectorAll("[data-offer-purchase-input]").forEach((input) => {
    input.checked = input.value === offerMode;
  });

  packageCards.forEach((card) => {
    const price = offerMode === "one-time" ? card.dataset.oneTimePrice : card.dataset.subscriptionPrice;
    const subcopy = offerMode === "one-time" ? card.dataset.oneTimeSubcopy : card.dataset.subscriptionSubcopy;
    const priceTarget = card.querySelector("[data-card-price]");
    const compareTarget = card.querySelector("[data-card-compare]");
    const subcopyTarget = card.querySelector("[data-card-subcopy]");
    const savingsTarget = card.querySelector("[data-card-savings]");
    if (priceTarget && price) priceTarget.textContent = price;
    if (compareTarget && card.dataset.comparePrice) compareTarget.textContent = card.dataset.comparePrice;
    if (subcopyTarget && subcopy) subcopyTarget.textContent = subcopy;
    if (savingsTarget) {
      const rate = offerMode === "one-time"
        ? card.dataset.oneTimeSavingsRate || 0
        : card.dataset.subscriptionTotalSavingsRate || card.dataset.subscriptionSavingsRate || 0;
      savingsTarget.textContent = `${rate}% Off Regular Price`;
    }
  });

  if (offerNote) {
    offerNote.textContent = offerMode === "one-time"
      ? "No subscription. Your selected package ships once."
      : "As a subscriber, you get the lowest price and shipments timed to when the boxes in your order finish.";
  }

  updateOfferSummary();
};

offerModeButtons.forEach((button) => {
  button.addEventListener("click", () => updateOfferMode(button.dataset.offerMode || "subscription"));
});

const defaultPackageCard = packageCards.find((card) => (
  card.dataset.boxLabel === "1 Box"
  && !card.querySelector('input[name="id"]')?.disabled
)) || packageCards[0];

const resetOfferDefaults = () => {
  updateOfferMode(subscriptionAvailable ? "subscription" : "one-time");
  if (defaultPackageCard) selectPackageCard(defaultPackageCard);
};

resetOfferDefaults();
window.addEventListener("pageshow", (event) => {
  if (event.persisted) resetOfferDefaults();
});

document.addEventListener("click", (event) => {
  const link = event.target.closest('a[href^="#"]');
  if (!link) return;
  const target = document.querySelector(link.getAttribute("href"));
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({ behavior: "smooth", block: "start" });
});

const dots = Array.from(document.querySelectorAll(".dots button"));
dots.forEach((dot) => {
  dot.addEventListener("click", () => {
    dots.forEach((item) => item.classList.toggle("active", item === dot));
  });
});

const researchModal = document.querySelector(".research-modal");
const researchModalTitle = document.querySelector("#research-modal-title");
const researchModalImage = document.querySelector(".research-modal__image");
const researchModalZoom = document.querySelector(".research-modal__zoom");
const researchModalCitation = document.querySelector(".research-modal__citation");
const researchModalSource = document.querySelector(".research-modal__source");
let researchLastFocus = null;

const closeResearchModal = () => {
  if (!researchModal) return;
  researchModal.classList.remove("is-open", "has-preview");
  researchModal.setAttribute("aria-hidden", "true");
  if (researchModalImage) researchModalImage.removeAttribute("src");
  researchModalZoom?.classList.remove("is-zoomed");
  researchModalZoom?.setAttribute("aria-pressed", "false");
  researchModalZoom?.setAttribute("aria-label", "Enlarge research summary");
  if (researchModalSource) researchModalSource.removeAttribute("href");
  document.body.style.overflow = "";
  if (researchLastFocus) researchLastFocus.focus();
};

const openResearchModal = (trigger) => {
  if (!researchModal) return;
  researchLastFocus = trigger;
  const title = trigger.getAttribute("data-research-title") || "Research Link";
  const image = trigger.getAttribute("data-research-image");
  const url = trigger.getAttribute("data-research-url");
  const citation = trigger.getAttribute("data-research-citation") || "";
  if (researchModalTitle) researchModalTitle.textContent = title;
  researchModal.classList.toggle("has-preview", Boolean(image));
  if (researchModalImage && image) {
    researchModalImage.setAttribute("src", image);
    researchModalImage.setAttribute("alt", `${title} one-page research summary`);
  }
  if (researchModalCitation) researchModalCitation.textContent = citation;
  if (researchModalSource && url) researchModalSource.setAttribute("href", url);
  researchModal.classList.add("is-open");
  researchModal.setAttribute("aria-hidden", "false");
  document.body.style.overflow = "hidden";
  researchModal.querySelector("[data-research-close]")?.focus();
};

researchModalZoom?.addEventListener("click", () => {
  const isZoomed = researchModalZoom.classList.toggle("is-zoomed");
  researchModalZoom.setAttribute("aria-pressed", String(isZoomed));
  researchModalZoom.setAttribute("aria-label", isZoomed ? "Reduce research summary" : "Enlarge research summary");
});

document.addEventListener("click", (event) => {
  const trigger = event.target.closest(".science-research-link");
  if (trigger) {
    event.preventDefault();
    openResearchModal(trigger);
    return;
  }

  if (event.target.closest("[data-research-close]")) {
    event.preventDefault();
    closeResearchModal();
  }
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape" && researchModal?.classList.contains("is-open")) {
    closeResearchModal();
  }
});
